var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrraper"},[_c('app-bar-top'),_c('app-header-inner'),_c('app-page-Title',{attrs:{"heading":_vm.heading,"sousHeading":_vm.sousHeading}}),_c('app-services'),_c('app-newsLetter',{class:'area'}),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }